module.exports = __webpack_public_path__ + "static/media/03.ba4817e1.png";